import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddOutlined";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import ArrowUpwardIcon from "@material-ui/icons/HeightOutlined";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import SaveIcon from "@material-ui/icons/Save";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  appBar: {
    // Ajustes adicionales si lo deseas
  },
  consolidatedBar: {
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    background: "#fff",
    borderRadius: 8,
    padding: "0 10px",
    border: "1px solid rgba(0,0,0,0.08)",
  },
  leftCluster: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 0,
    flex: 1,
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    minWidth: 0,
    fontSize: 13,
    color: "rgba(0,0,0,0.7)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  breadcrumbStrong: {
    fontWeight: 600,
    color: "rgba(0,0,0,0.88)",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 0,
    marginTop: "10px",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  tabsContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "0px",
  },
  tabs: {
    // marginRight: theme.spacing(4),
    // color: '#0076FF',
  },
  tab: {
    fontSize: "14px",
    textTransform: "none",
    fontWeight: 500,
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: 8,
  },
  searchInput: {
    marginLeft: theme.spacing(2),
    backgroundColor: "#fff",
    width: "100%",
    height: "36px",
    textTransform: "none",
  },
  searchButton: {
    marginLeft: 4,
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  title: {
    color: "#0076FF",
    fontSize: "32px",
    margin: 0,
    padding: 0,
    [theme.breakpoints.down("sm")]: {
      fontSize: "24px",
    },
  },
  newTemplateButton: {
    marginLeft: "20px",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 8,
    },
  },
}));

export default function HeaderViewer({
  tabValue,
  onTabChange,
  onSaveAndClose,
  onSaveAndSend,
  onClose,
  onAddField,
  showFolderWarning = false,
  onSelectFolder,
  templateName,
  onAppendPage,
  onDeletePage,
  onMovePage,
  hasSelectedPage = false,
  pageCount = 1,
  currentPage = 1,
}) {
  const classes = useStyles();
  const handleChangeTab = (event, newValue) => {
    onTabChange(newValue);
  };
  // Move modal state
  const [moveOpen, setMoveOpen] = useState(false);
  const [moveAction, setMoveAction] = useState("first");
  const [movePageInput, setMovePageInput] = useState(1);
  const [moveError, setMoveError] = useState("");

  const openMoveDialog = () => {
    setMoveAction("first");
    setMovePageInput(1);
    setMoveError("");
    setMoveOpen(true);
  };
  const closeMoveDialog = () => setMoveOpen(false);

  const submitMove = () => {
    setMoveError("");
    const v = parseInt(movePageInput, 10);
    if (moveAction === "page" && (isNaN(v) || v < 1 || v > pageCount)) {
      setMoveError(`Enter a page between 1 and ${pageCount}`);
      return;
    }

    if (onMovePage) {
      if (moveAction === "first" || moveAction === "last")
        onMovePage({ action: moveAction });
      else if (moveAction === "page") onMovePage(v);
      else if (moveAction === "down") onMovePage("down");
      else if (moveAction === "up") onMovePage("up");
    }
    closeMoveDialog();
  };

  const { selectedFile } = useSelector((state) => ({
    responseUploadFile: state.fileReducer.uploadResponse,
    selectedFile: state.fileReducer.selectedFile,
  }));

  return (
    <div>
      <header position="static" className={classes.appBar}>
        {showFolderWarning && (
          <div
            style={{
              marginTop: 8,
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid rgba(211, 47, 47, 0.45)",
              background: "rgba(211, 47, 47, 0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
            }}
          >
            <div>
              <div style={{ fontWeight: 600, color: "#b71c1c" }}>
                No destination folder
              </div>
              <div style={{ fontSize: 12, color: "rgba(0,0,0,0.7)" }}>
                Required before saving
              </div>
            </div>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onSelectFolder}
              style={{ textTransform: "none" }}
            >
              Select folder
            </Button>
          </div>
        )}
        <div className={classes.consolidatedBar}>
          <div className={classes.leftCluster}>
            <div className={classes.breadcrumb} title={templateName || ""}>
              <span className={classes.breadcrumbStrong}>Templates</span>
              <span style={{ opacity: 0.55 }}>&rsaquo;</span>
              <span className={classes.breadcrumbStrong} style={{ maxWidth: 260 }}>
                {templateName || "Untitled template"}
              </span>
            </div>

            <div className={classes.tabsContainer} style={{ background: "transparent" }}>
              <Tabs
                value={tabValue}
                onChange={handleChangeTab}
                className={classes.tabs}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="Builder" className={classes.tab} />
                <Tab label="Preview" className={classes.tab} />
              </Tabs>
            </div>

            <Button
              variant="contained"
              color="primary"
              className={classes.newTemplateButton}
              onClick={onAddField}
            >
              Add Field
            </Button>
          </div>

          <div className={classes.rightSection}>
            <IconButton
              size="small"
              onClick={onClose}
              title="Close"
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            <Button
              variant="outlined"
              color="primary"
              className={classes.searchButton}
              onClick={onSaveAndSend}
            >
              <SendIcon style={{ verticalAlign: "middle", marginRight: 4 }} />
              Send
            </Button>

            <Button
              variant="contained"
              color="primary"
              className={classes.searchButton}
              onClick={onSaveAndClose}
            >
              <SaveIcon style={{ verticalAlign: "middle", marginRight: 4 }} />
              Save & Close
            </Button>
          </div>

          {/* Move dialog */}
          <Dialog
            open={moveOpen}
            onClose={closeMoveDialog}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>Reorder Page {currentPage} </DialogTitle>
            <DialogContent>
              <RadioGroup
                value={moveAction}
                onChange={(e) => setMoveAction(e.target.value)}
              >
                {currentPage !== 1 && (
                  <FormControlLabel
                    value="first"
                    control={<Radio />}
                    label="Move to First"
                  />
                )}
                {currentPage !== pageCount && (
                  <FormControlLabel
                    value="last"
                    control={<Radio />}
                    label="Move to Last"
                  />
                )}
                <hr style={{ margin: "8px 0" }} />
                <FormControlLabel
                  value="up"
                  control={<Radio />}
                  label="Move Up"
                />
                <FormControlLabel
                  value="down"
                  control={<Radio />}
                  label="Move Down"
                />
                <hr style={{ margin: "8px 0" }} />
                <FormControlLabel
                  value="page"
                  control={<Radio />}
                  label="Move to Page"
                />
              </RadioGroup>
              {moveAction === "page" && (
                <TextField
                  type="number"
                  label="Page"
                  value={movePageInput}
                  onChange={(e) => setMovePageInput(e.target.value)}
                  inputProps={{ min: 1, max: pageCount }}
                  fullWidth
                />
              )}
              {moveError && (
                <div style={{ color: "red", marginTop: 8 }}>{moveError}</div>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={closeMoveDialog}>Cancel</Button>
              <Button color="primary" onClick={submitMove}>
                Move
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </header>
    </div>
  );
}
